import PropTypes from 'prop-types'
import React from 'react'
import Checkbox from '#components/a/form/Checkbox'

export default function ReadOnlyTask({task: {done, text}}) {
  return (
    <div className={done ? 'task task--done' : 'task'}>
      <Checkbox modifier="disabled" disabledState checked={done} labelText={text} />
    </div>
  )
}

ReadOnlyTask.propTypes = {
  task: PropTypes.shape({
    text: PropTypes.string,
    done: PropTypes.bool,
  }).isRequired,
}
